import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_EXTENDED } from "@/data/faqExtended";

export function FaqExtended() {
  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      className="mx-auto mt-20 mb-12 w-full max-w-4xl px-4"
    >
      <div className="mb-8 text-center">
        <p className="mb-2 text-xs font-bold uppercase tracking-[0.25em] text-primary">FAQ</p>
        <h2 id="faq-title" className="text-2xl font-extrabold tracking-tight text-foreground sm:text-3xl md:text-4xl">
          20 вопросов, на которые мы отвечаем честно
        </h2>
      </div>

      <div className="grid gap-5 md:grid-cols-2">
        {FAQ_EXTENDED.map((cat, ci) => (
          <motion.div
            key={cat.title}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: ci * 0.05 }}
            className="glass-card p-5"
          >
            <h3 className="mb-3 text-sm font-bold uppercase tracking-wider text-primary">{cat.title}</h3>
            <Accordion type="single" collapsible className="w-full">
              {cat.items.map((item, i) => (
                <AccordionItem key={i} value={`${cat.title}-${i}`} className="border-border/40">
                  <AccordionTrigger className="text-left text-sm text-foreground hover:no-underline hover:text-primary">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
